import { FilterModalTypes } from '../../components/FilterModal';
import { SectionTypes } from '../../components/FilterModal/filters/Section';

export const TransactionFlowAvailableFilter = [
  {
    type: 'section',
    title: 'Período desejado',
    fieldName: 'periodType',
    optionsColumns: 1,
    onlyOneSelection: true,
    options: [
      { label: 'Último 7 dias', value: '7' },
      { label: 'Último 15 dias', value: '15' },
      { label: 'Outro período', value: 'outros' },
    ],
  },
  {
    type: 'dateRange',
    fieldName: 'positionDate',
    title: '',
    placeholder: 'Selecione',
    maxDaysRange: 30,
    showOnlyIf: (selectedFilters) => {
      const typePeriodSelected = selectedFilters.find(
        (filter) => filter.fieldName === 'periodType'
      );
      return (typePeriodSelected?.filter as SectionTypes.SelectionProps)?.includes('outros');
    },
  },
  {
    type: 'select',
    title: 'Tipo de Produto',
    fieldName: 'productType',
    placeholder: 'Selecione',
    options: [
      { label: 'Todos', value: '0' },
      { label: 'Fundos de Investimento', value: '1' },
      { label: 'Renda Fixa', value: '2' },
      { label: 'Tesouro Direto', value: '3' },
      { label: 'Conta Corrente', value: '4' },
      { label: 'Renda Variavel', value: '5' },
      { label: 'Margem Requerida', value: '6' },
      { label: 'Oferta Pública', value: '7' },
    ],
  },
] as FilterModalTypes.FilterType[];
